require 'summernote'
require('../locales/summernote-pt_BR.coffee')

module.exports = (target) ->
  jQuery(target).summernote(
    lang: 'pt-BR'
    height: 180
    fontSizes: ['8', '9', '10', '11', '12', '13', '14', '16', '18', '24', '36', '48', '72']
    toolbar: [
      ['style', ['bold', 'italic', 'underline', 'strikethrough']],
      ['para', ['ul', 'ol']],
      ['picture', ['picture']],
      ['link', ['link']]
    ],
    disableResizeEditor: true
  )



// WEBPACK FOOTER //
// ./src/libraries/summernote_comments.coffee